module.exports = __webpack_public_path__ + "images/stickers/taco-proto@2x.51def85cdcf3c1a58cb1.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/taco-proto@2x.png
// module id = RZdR
// module chunks = 2